/**
 * Auth API — login va session endpointlar
 *
 * Backend (Faza 4):
 *   POST /auth/login         → { token, user }
 *   POST /auth/first-owner   → { token, user }
 *   GET  /auth/me            → user
 */

import type {
  AuthTokenPayload,
  CreateFirstOwnerInput,
  ImpersonateInput,
  ImpersonateResponse,
  LoginInput,
  LoginResponse,
  UserDto,
} from '@avtofix/shared';

import { apiClient } from '@/shared/lib/api-client';

export const authApi = {
  login: async (input: LoginInput): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/auth/login', input);
  },

  createFirstOwner: async (input: CreateFirstOwnerInput): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/auth/first-owner', input);
  },

  getMe: async (): Promise<UserDto> => {
    return apiClient.get<UserDto>('/auth/me');
  },

  /**
   * Login As (impersonation) — EGASI/ADMIN boshqa user sifatida kiradi.
   * Yangi token originalUserId ni saqlaydi (stop uchun).
   */
  impersonate: async (input: ImpersonateInput): Promise<ImpersonateResponse> => {
    return apiClient.post<ImpersonateResponse>('/auth/impersonate', input);
  },

  /**
   * Asl hisobga qaytish — impersonation token'ini asl user token'iga almashtirish.
   */
  stopImpersonation: async (): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/auth/impersonate/stop', {});
  },
};

/**
 * JWT token'ni decode qilish (signature verify YO'Q — faqat client-side display uchun)
 * Server JWT'ni har request'da qayta tekshiradi.
 */
export function decodeJwtPayload(token: string): AuthTokenPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }
    const base64 = parts[1]?.replace(/-/g, '+').replace(/_/g, '/') ?? '';
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);
    return JSON.parse(json) as AuthTokenPayload;
  } catch {
    return null;
  }
}
